import { render, staticRenderFns } from "./wsButtonGroup.vue?vue&type=template&id=fbb67de0&scoped=true&"
import script from "./wsButtonGroup.vue?vue&type=script&lang=js&"
export * from "./wsButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./wsButtonGroup.vue?vue&type=style&index=0&id=fbb67de0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbb67de0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VIcon,VSheet})
